// Devanagari → IAST transliteration for Prakrit (अहं पढामि → ahaṃ paḍhāmi).
// Deterministic; the inherent अ is always written (Prakrit, unlike Hindi, keeps it).

const VOWELS: Record<string, string> = {
    'अ': 'a', 'आ': 'ā', 'इ': 'i', 'ई': 'ī', 'उ': 'u', 'ऊ': 'ū', 'ऋ': 'ṛ', 'ॠ': 'ṝ', 'ऌ': 'ḷ',
    'ए': 'e', 'ऐ': 'ai', 'ओ': 'o', 'औ': 'au', 'ऍ': 'ê', 'ऑ': 'ô'
}

const SIGNS: Record<string, string> = {
    'ा': 'ā', 'ि': 'i', 'ी': 'ī', 'ु': 'u', 'ू': 'ū', 'ृ': 'ṛ', 'ॄ': 'ṝ', 'ॢ': 'ḷ',
    'े': 'e', 'ै': 'ai', 'ो': 'o', 'ौ': 'au', 'ॅ': 'ê', 'ॉ': 'ô'
}

const CONSONANTS: Record<string, string> = {
    'क': 'k', 'ख': 'kh', 'ग': 'g', 'घ': 'gh', 'ङ': 'ṅ',
    'च': 'c', 'छ': 'ch', 'ज': 'j', 'झ': 'jh', 'ञ': 'ñ',
    'ट': 'ṭ', 'ठ': 'ṭh', 'ड': 'ḍ', 'ढ': 'ḍh', 'ण': 'ṇ',
    'त': 't', 'थ': 'th', 'द': 'd', 'ध': 'dh', 'न': 'n',
    'प': 'p', 'फ': 'ph', 'ब': 'b', 'भ': 'bh', 'म': 'm',
    'य': 'y', 'र': 'r', 'ल': 'l', 'व': 'v', 'श': 'ś', 'ष': 'ṣ', 'स': 's', 'ह': 'h', 'ळ': 'ḷ'
}

const NUKTA: Record<string, string> = { 'ड': 'ṛ', 'ढ': 'ṛh', 'क': 'q', 'ख': 'x', 'ग': 'ġ', 'ज': 'z', 'फ': 'f' }

const OTHER: Record<string, string> = {
    'ं': 'ṃ', 'ँ': 'm̐', 'ः': 'ḥ', 'ऽ': "'", '।': '.', '॥': '.',
    '०': '0', '१': '1', '२': '2', '३': '3', '४': '4', '५': '5', '६': '6', '७': '7', '८': '8', '९': '9'
}

const VIRAMA = '्'
const NUKTA_SIGN = '़'

export const transliterate = (text: string, { punctuation = false }: { punctuation?: boolean } = {}): string => {
    const chars = Array.from(text.normalize('NFD'))
    let out = ''

    for (let i = 0; i < chars.length; i += 1) {
        const ch = chars[i]
        const next = chars[i + 1]

        if (ch in CONSONANTS) {
            let base = CONSONANTS[ch]
            let j = i + 1

            if (next === NUKTA_SIGN) {
                base = NUKTA[ch] ?? base
                j += 1
            }

            const after = chars[j]

            if (after === VIRAMA) {
                out += base
                i = j
            }
            else if (after !== undefined && after in SIGNS) {
                out += base + SIGNS[after]
                i = j
            }
            else {
                out += base + 'a'
                i = j - 1
            }

            continue
        }

        if (ch in VOWELS) {
            out += VOWELS[ch]
            continue
        }

        if (ch in OTHER) {
            const value = OTHER[ch]

            if (!punctuation && (ch === '।' || ch === '॥')) continue

            out += value
            continue
        }

        if (ch === NUKTA_SIGN || ch === VIRAMA || ch === '‌' || ch === '‍') continue

        out += ch
    }

    return out.replace(/\s+/g, ' ').trim()
}
